import dealWidget from '@/views/landingPage/dealWidget/DealWidget.vue';
import SwitchLabel from '@/views/landingPage/switchLabel/SwitchLabel.vue';
import AdvertisingSpace from '@/views/landingPage/advertisingSpace/AdvertisingSpace.vue';
import Introduction from '@/views/landingPage/introduction/Introduction.vue';
import AsinShowcase from '@/views/landingPage/asinShowcase/AsinShowcase.vue';
import RotationPoster from '@/views/landingPage/rotationPoster/RotationPoster.vue';
import MapArea from '@/views/landingPage//mapArea/MapArea.vue';
import Bestseller from '@/views/landingPage//bestseller/Bestseller.vue';
import StoreAnnouncement from '@/views/landingPage//storeAnnouncement/StoreAnnouncement.vue';
import CouponWidget from '@/views/landingPage//couponWidget/CouponWidget.vue';
import Shortcut from '@/views/landingPage//shortcut/Shortcut.vue';
export const gatewayWidgetComponents = [
  {
    type: 'dealWidget',
    component: dealWidget
  },
  {
    type: 'recommendedAsin',
    component: AsinShowcase
  },
  {
    type: 'tabSwitch',
    component: SwitchLabel
  },
  {
    type: 'imageBanner',
    component: AdvertisingSpace
  },
  {
    type: 'TAndC',
    component: Introduction
  },
  {
    type: 'TCG',
    component: RotationPoster
  },
  {
    type: 'hotspotCarousel',
    component: MapArea
  },
  {
    type: 'bestseller',
    component: Bestseller
  },
  {
    type: 'storeAnnouncement',
    component: StoreAnnouncement
  },
  {
    type: 'couponWidget',
    component: CouponWidget
  },
  {
    type: 'shortcut',
    component: Shortcut
  }
];

export const SHOW_TYPE = {
  HIDE: false,
  DISPLAY: true
};
export const LAYOUT_TYPE = {
  HORIZONTAL: 'TRANSVERSE',
  TWO_COLUMN: 'ROW_TWO',
  THREE_COLUMN: 'ROW_THREE'
};
export const TEXT_BOLD_TYPE = {
  BOLD: 'bold',
  NORMAL: 'normal'
};
export const FILL_TYPE = {
  SOLID_COLOR: 'SOLID_COLOR',
  PICURL: 'PICURL'
};
export const SLIDE_TYPE = {
  MANUAL: 'MANUAL',
  AUTOMATIC: 'AUTOMATIC'
};
export const CIRCULATE_TYPE = {
  LOOP: 'LOOP',
  NORMAL: 'NORMAL'
};
export const SHOW_MORE_TYPE = {
  DISPLAY: 'DISPLAY',
  HIDE: 'HIDE'
};
export const DISPLAY_MODE = {
  WATERFALL: 'WATERFALL',
  NORMAL: 'NORMAL'
};
export const LOGINTOOLTIP_ID = 'loginToolTipId';
